import request from './index';

export function login(key) {
  return request.post('login', key);
}

